import React, { useEffect, useRef, useState } from 'react'
import { Link } from '../../components/index.js'
import { debounce } from 'es-toolkit'
import { useAiuiContext } from '../AiuiProvider/index.js'
import { getLocalizedPath } from '../../helpers/utils.js'

/**
 * supports下拉
 * @param categoriesItem 分类项
 * @param currentNavItemRef 当前导航项
 */
export const SupportsDropdown = ({
  supportsMetadata,
  currentNavItemRef,
}: {
  supportsMetadata: any
  currentNavItemRef: HTMLDivElement
}) => {
  const { locale = 'us' } = useAiuiContext()
  const supportsDropdownRef = useRef<HTMLDivElement>(null)
  const [navItemReact, setNavItemReact] = useState<DOMRect | null>(null)
  const [supportsDropdownHeight, setSupportsDropdownHeight] = useState(0)

  useEffect(() => {
    if (supportsDropdownRef?.current) {
      const rect = supportsDropdownRef?.current?.getBoundingClientRect()
      setSupportsDropdownHeight(rect.height)
    }
  }, [supportsDropdownRef])

  const debouncedHandleResize = debounce(() => {
    if (currentNavItemRef) {
      const rect = currentNavItemRef.getBoundingClientRect()
      setNavItemReact(rect)
    }
  }, 500)

  useEffect(() => {
    debouncedHandleResize()
    window.addEventListener('resize', debouncedHandleResize)
    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  }, [debouncedHandleResize])

  useEffect(() => {
    if (currentNavItemRef) {
      const rect = currentNavItemRef.getBoundingClientRect()
      setNavItemReact(rect)
    }
  }, [currentNavItemRef])

  return (
    <div
      className="absolute top-0 h-full overflow-hidden bg-white transition-all duration-500"
      style={{ right: `calc(100% - ${navItemReact?.right}px)`, height: supportsDropdownHeight }}
    >
      <div ref={supportsDropdownRef} className="p-4">
        {supportsMetadata?.map((supportItem: any) => (
          <div key={supportItem.id} className="py-2">
            <Link
              href={getLocalizedPath(supportItem.url, locale)}
              className="text-sm font-bold leading-[1.4] no-underline"
            >
              {supportItem.label}
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}
